module.exports = __webpack_public_path__ + "static/media/mage.cc4b9369.gif";